export function trim(str: string, onlyEnds?: boolean): string {
  if (typeof str !== 'string') {
    return str;
  }

  if (onlyEnds) {
    return str.trim();
  }

  return str.trim().replace(/\s+/g, ' ');
}

export function trimLongText(text: string, symbols = 40): string {
  if (text.length < symbols) {
    return text;
  }

  return text.slice(0, symbols).concat('...');
}

export function trimData<T extends object>(data: T): T {
  return Object.entries(data).reduce<T>((acc, [name, value]) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    acc[name] = trim(value);

    return acc;
  }, {} as T);
}

export function unCapitalize(str: string) {
  return str.charAt(0).toLowerCase() + str.slice(1);
}

export function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function getIdFromPath(path: string) {
  return Number(path.substring(path.lastIndexOf('/') + 1));
}

export function removeSpaces(str: string) {
  return str.replace(/\s/g, '');
}
